// Per-country aircon pricing constants.
//
// These MIRROR the backend AIRCON_PRICING_PROFILE rows that drive
// util/AirconCostCalculator.java - the backend is the price authority for
// bookings; this copy only renders the static price tables on SEO pages at
// build time. If you change a number here, change the backend seed in the same
// release, or the page will advertise a price the booking flow won't charge.
//
// The SG row started as the legacy hardcoded constants (js/aircon-cost
// reproduced the old tables to the cent). Oct 2026 price review: general +4%
// (base 22.5 -> 23.5), wash +2% (45 -> 46), overhaul +3% (81 -> 83.43), new
// Chemical Hydro Wash (66). 1 unit: 49.68 general, 84.64 wash, 121.44 hydro
// wash, 153.51 overhaul.
//
// Field names follow the formula in AirconCostCalculator:
//   general, 1 unit  = 2*base + firstUnitAdjustment
//   general, n units = base*(1+n) - generalDiscountFactor%*base*n - unitStep*(n-5)
//                      (- bulkDeduction when n > 4)
//   chemical, 1 unit = 2*B ; n units = B*(n+1) + chemicalDiscountFactor%*B*n
//   condenser/flush  = B*n - generalDiscountFactor%*base*n - unitStep*(n-3)
// then the category discount (REQUEST_CATEGORY_SETTINGS.discountPercent, 8%).
//
// Market rationale for AE/MY (Oct 2026 research) is in the expansion plan:
// launched ~20-35% under the leading aggregator in each city; raised on
// 2026-10-23 to sit just under it (UAE 1-unit cleaning AED 138 vs ~179, KL
// general service RM 98 vs RM 80-120).

export const AIRCON_PRICING_PROFILES = {
    sg: {
        currency: 'SGD',
        discountPercent: 8,
        base: 23.5,
        firstUnitAdjustment: 7,
        generalDiscountFactor: 18,
        unitStep: 1,
        bulkDeduction: 5,
        chemicalBasicBase: 46,
        // Chemical Hydro Wash (SG only): partial dismantle + water-jet rinse,
        // between wash and overhaul. 0 / absent = not offered in that market.
        chemicalHydroBase: 66,
        chemicalOverhaulBase: 83.43,
        chemicalDiscountFactor: 45,
        intervalDiscountFactor: 2,
        // Ceiling/ducted uplift. SG's multi-unit general uplift is the legacy
        // "75% + base%" (base used as a percentage) = 97.5%.
        mountUpliftGeneralSingle: 20,
        mountUpliftGeneralMulti: 97.5,
        mountUpliftChemical: 200,
        condenserBase: 75,
        condenserChemicalBase: 120,
        pipeFlushBase: 60,
        repairFlat: 50,
        gas: {
            R410A: { low: 72, high: 160 },
            R32: { low: 110, high: 210 },
            R22: { low: 50, high: 110 },
        },
    },

    ae: {
        currency: 'AED',
        discountPercent: 8,
        base: 100,
        firstUnitAdjustment: -50,
        generalDiscountFactor: 18,
        unitStep: 2.5,
        bulkDeduction: 12,
        chemicalBasicBase: 125,
        chemicalOverhaulBase: 210,
        chemicalDiscountFactor: 45,
        intervalDiscountFactor: 2,
        mountUpliftGeneralSingle: 20,
        mountUpliftGeneralMulti: 40,
        mountUpliftChemical: 60,
        condenserBase: 150,
        condenserChemicalBase: 240,
        pipeFlushBase: 150,
        repairFlat: 119,
        gas: {
            R410A: { low: 165, high: 330 },
            R32: { low: 195, high: 360 },
            R22: { low: 140, high: 275 },
        },
    },

    my: {
        currency: 'MYR',
        discountPercent: 8,
        base: 65,
        firstUnitAdjustment: -23,
        generalDiscountFactor: 18,
        unitStep: 2,
        bulkDeduction: 10,
        chemicalBasicBase: 88,
        chemicalOverhaulBase: 150,
        chemicalDiscountFactor: 45,
        intervalDiscountFactor: 2,
        mountUpliftGeneralSingle: 20,
        mountUpliftGeneralMulti: 60,
        mountUpliftChemical: 100,
        condenserBase: 100,
        condenserChemicalBase: 160,
        pipeFlushBase: 100,
        repairFlat: 60,
        gas: {
            R410A: { low: 70, high: 140 },
            R32: { low: 80, high: 150 },
            R22: { low: 60, high: 115 },
        },
    },
}

export const getAirconPricingProfile = (countryCd) =>
    AIRCON_PRICING_PROFILES[(countryCd || 'sg').toLowerCase()] ?? AIRCON_PRICING_PROFILES.sg
